import { FC, ReactElement } from 'react'

export interface ConditionalWrapperProps {
  condition: boolean
  wrapper: (el: ReactElement) => ReactElement
  children: ReactElement
}

export const ConditionalWrapper: FC<ConditionalWrapperProps> = ({
  condition,
  wrapper,
  children,
}): ReactElement => (condition ? wrapper(children) : children)
